import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  ADD_USER_BUTTON: `${cleanedFilename(__filename)}-add-user-button`,
};
